import script from "./whGOnceImg4.vue?vue&type=script&setup=true&lang=js"
export * from "./whGOnceImg4.vue?vue&type=script&setup=true&lang=js"

import "./whGOnceImg4.vue?vue&type=style&index=0&id=40312f21&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40312f21"]])

export default __exports__